/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Superset_Not_ConsecutiveInputs */

const en_us2_plan_superset_not_consecutive = /** @type {(inputs: Plan_Superset_Not_ConsecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only exercises next to each other in the workout can be grouped as a superset.`)
};

const pt_br2_plan_superset_not_consecutive = /** @type {(inputs: Plan_Superset_Not_ConsecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só dá para juntar em superset exercícios que estão um ao lado do outro no treino.`)
};

const es_419_plan_superset_not_consecutive = /** @type {(inputs: Plan_Superset_Not_ConsecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se pueden agrupar en superserie ejercicios que están uno al lado del otro en el entrenamiento.`)
};

const pt_pt2_plan_superset_not_consecutive = /** @type {(inputs: Plan_Superset_Not_ConsecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só podes juntar em superset exercícios que estejam seguidos no treino.`)
};

const fr_fr2_plan_superset_not_consecutive = /** @type {(inputs: Plan_Superset_Not_ConsecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuls des exercices qui se suivent dans la séance peuvent former un superset.`)
};

const de_de2_plan_superset_not_consecutive = /** @type {(inputs: Plan_Superset_Not_ConsecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Übungen, die im Training direkt aufeinander folgen, lassen sich zu einem Supersatz zusammenfassen.`)
};

const it_it2_plan_superset_not_consecutive = /** @type {(inputs: Plan_Superset_Not_ConsecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo esercizi uno accanto all'altro nell'allenamento possono formare un superset.`)
};

/**
* | output |
* | --- |
* | "Only exercises next to each other in the workout can be grouped as a superset." |
*
* @param {Plan_Superset_Not_ConsecutiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_superset_not_consecutive = /** @type {((inputs?: Plan_Superset_Not_ConsecutiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Superset_Not_ConsecutiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_superset_not_consecutive(inputs)
	if (locale === "es-419") return es_419_plan_superset_not_consecutive(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_superset_not_consecutive(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_superset_not_consecutive(inputs)
	if (locale === "de-DE") return de_de2_plan_superset_not_consecutive(inputs)
	if (locale === "it-IT") return it_it2_plan_superset_not_consecutive(inputs)
	return en_us2_plan_superset_not_consecutive(inputs)
});
export { plan_superset_not_consecutive as "plan.superset_not_consecutive" }